import { Box } from "@mui/material";
import { getAppLocale } from "../../utils/i18nLanguage";

const LanguageFlag = ({ language, sx = {} }) => {
  const flagClass = getAppLocale(language).flagClass;

  return (
    <Box
      component="span"
      className={flagClass}
      sx={{
        fontSize: 18,
        borderRadius: "50%",
        display: "inline-block",
        ...sx,
      }}
    />
  );
};

export default LanguageFlag;
